import Nullstack from 'nullstack';
export default function IconCurrencyBahraini({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-bahraini",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 10v1a4 4 0 0 0 4 4h2a2 2 0 0 0 2 -2v-3"
  }), "   ", Nullstack.element("path", {
    d: "M7 19.01v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M14 15.01v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M17 15h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
  }), " ");
}